var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeesho(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 92,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M0 0L0 92L96 92L96 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M96 0L96 92L97 92L97 28L96 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M64 37L64 38L67 39L64 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M64 38L64 58L65 58L64 39L66 39L68 46L66 38L64 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M62 39L62 51L56 48L56 49C60.2459 51.2846 61.6301 53.3338 60 58C64.599 54.6832 64.0574 43.9032 62 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M64 39L64 57L66 57C66.0536 52.4614 66.2976 49.4275 71 48L71 57C76.9584 52.7895 72.8294 44.8787 66 46L66 39L64 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M67 40L67 45C73.9202 46.0806 73.9953 50.9694 74 57L75 57C75.7646 50.5858 75.3217 45.1345 68 44L67 40M11 44L11 45L17 46L11 44M18 44L18 45C24.9202 46.0806 24.9953 50.9694 25 57L26 57L28 56C25.9304 49.6331 25.8825 44.5947 18 44M30 44L30 45L35 45L30 44M43 44L43 45L48 45L43 44M55 44L55 45L60 45L55 44M80 44L80 45L83 45L80 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M10 45L9 47L10 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M11 45L12 46L11 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M9 57L11 57L13 47L14 47L16 57L18 57L18 48L22 48L25 57C24.9898 41.5668 9.01022 41.5668 9 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M15 45L16 46L15 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M17 45L18 46L17 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M18 45L19 46L18 45M22 45L23 46L22 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M28 45L27 47L28 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M29 45L30 46L29 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M30 45L31 46L30 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M37 54L29 52L38 52C36.7184 45.8367 27.9586 42.7393 27.3372 51C26.8855 57.0043 34.1245 58.4313 37 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M33.6667 45.3333L34.3333 45.6667L33.6667 45.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M35 45L37 47L35 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M36 45L37 46L36 45M41 45L38 52L30 54L34 53L34 54L32 54L32 55L39 53L41 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M42 45L43 46L42 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M43 45L44 46L43 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M50 54L42 52L50 52C49.5377 46.05 41.9889 42.6461 40.3372 50.0432C38.8938 56.5072 46.7453 59.0196 50 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M46.6667 45.3333L47.3333 45.6667L46.6667 45.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M53 45L52 47L53 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M54 45L55 46L54 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M55 45L56 46L55 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M59 55L53 54C54.7002 56.6197 61.8005 58.3247 60.9406 53.1651C60.5807 51.0057 57.4712 49.3953 56 48L61 48C59.2699 45.7604 53.6479 44.3208 53.6358 48.8966C53.6293 51.3548 57.4656 53.4164 59 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M58.6667 45.3333L59.3333 45.6667L58.6667 45.3333M71 45L72 46L71 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M78 45L79 46L78 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M79 45L80 46L79 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M80 45L80 46L84 46L80 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M84 45L85 46L84 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M28 46L29 47L28 46M41 46L42 47L41 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M49 46L50 47L49 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M53 46L54 47L53 46M72 46L73 47L72 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M77 46L76 48L77 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffebfe",
      stroke: "none"
    },
    d: "M78.3179 47.0285C72.6038 50.7933 78.6926 60.3465 84.7708 56.1265C90.9833 51.8134 84.2538 43.1177 78.3179 47.0285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M85 46L86 47L85 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M86 46L88 54L89 54L86 46M8 47L9 48L8 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M9 47L10 48L9 47M13 47L14 48L13 47M24 47L25 48L24 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M27 47L28 48L27 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M32 47L33 48L32 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M37 47L38 48L37 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M40 47L41 48L40 47M45 47L46 48L45 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M50 47L51 52L43 52C45.0196 54.9952 46.8362 54.2556 50 53L54 58L53 51L53 54L58 55L50 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M52 47L53 48L52 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M73.3333 47.6667L73.6667 48.3333L73.3333 47.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M86 47L87 48L86 47M8 48L9 49L8 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M12 48L12 56L13 56L13 49L14 49L14 56L15 56L15 48L12 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M18 48L19 49L18 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M19 48L19 49L24 59L19 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M21 48L22 49L21 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M27 48L28 49L27 48M30 48C31.7685 50.0339 33.2315 50.0339 35 48L30 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M31 48L31 49L34 49L31 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M37 48L38 49L37 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M43 48L44 49L43 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M44 48L44 49L47 49L44 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M47 48L43 49L43 50L47 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M50 48L51 49L50 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M52 48L53 49L52 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M59.6667 48.3333L60.3333 48.6667L59.6667 48.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M67 50L70 49L67 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M70 48L71 49L70 48M79 48L78 50L79 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M79 49L79 50L84 50L79 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M83 48L84 49L83 48M8 49L8 56L9 56L8 49M11 49L11 56L12 56L11 49M15 49L16 58L17 58L15 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M18 49L17 58L18 58L18 49M39 49L40 50L39 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M50 49L50 52L51 52L50 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M52 49L53 50L52 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M56 49L57 50L56 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M57 49L58 50L57 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M66 49L67 50L66 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M70 49L71 50L70 49M75 49L76 50L75 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M79 50L80 54C84.3053 52.5691 83.4681 49.3109 79 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M84.3333 49.6667L84.6667 50.3333L84.3333 49.6667M87 49L88 50L87 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M26 50L26 53L27 53L26 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M39 50L39 53L40 53L39 50M59 50L60 51L59 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M66 50L66 56L67 56L66 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M70 50L70 58L71 58L70 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M75 50L75 53L76 53L75 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M78 50L78 53L79 53L78 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M22 51L23 52L22 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M52 51L51 54L54 52L52 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M54 51L55 52L54 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M84 51L85 52L84 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M7 52L7 56L8 56L7 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M29 52L30 53L29 52M42 52L43 53L42 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M55 52L56 53L55 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M56 52L57 53L56 52M61 52L62 53L61 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M79 52L84 54L84 53L79 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M84.3333 52.6667L84.6667 53.3333L84.3333 52.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M31 53L31 54L34 54L31 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M35 53L35 54L38 55L35 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M37.6667 53.3333L38.3333 53.6667L37.6667 53.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M39 53L40 54L39 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f43397",
      stroke: "none"
    },
    d: "M44 53L44 54L47 54L44 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M48.6667 53.3333L49.3333 53.6667L48.6667 53.3333M58.3333 53.6667L58.6667 54.3333L58.3333 53.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M75 53L76 54L75 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M78 53L79 54L78 53M87 53L88 54L87 53M27 54L28 55L27 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M31 54L32 55L31 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M34 54L35 55L34 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M38.6667 54.3333L39.3333 54.6667L38.6667 54.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M43 54L44 55L43 54M47 54L48 55L47 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M50.3333 54.6667L50.6667 55.3333L50.3333 54.6667M52 54L53 55L52 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M55 54L56 55L55 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M56 54L57 55L56 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M79 54L80 55L79 54M83 54L84 55L83 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M87 54L88 55L87 54M37 55L36 57L37 55M40 55L42 57L40 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M52 55L53 56L52 55M61 55L62 56L61 55M73 55L72 58L73 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M76 55L77 56L76 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M86 55L85 57L86 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M87 55L88 56L87 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M8 56L8 57L12 57L12 56L8 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M22 56L23 57L22 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M28 56L29 57L28 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M29 56L29 57L35 58L35 57L29 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M37 56L38 57L37 56M40 56L41 57L40 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M49 56L50 57L49 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M53 56L54 57L53 56M60 56L61 57L60 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M77 56L78 57L77 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M86 56L87 57L86 56M8 57L9 58L8 57M11 57L12 58L11 57M15 57L16 58L15 57M18 57L19 58L18 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M23 57L24 58L23 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M24 57L25 58L24 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M29 57L30 58L29 57M35 57L36 58L35 57M42 57L43 58L42 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M43 57L43 58L48 58L43 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M48 57L49 58L48 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M54 57L55 58L54 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M55 57L55 58L59 58L55 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M59 57L60 58L59 57M65 57L66 58L65 57M71 57L72 58L71 57M73 57L74 58L73 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M78 57L78 58L84 59L84 58L78 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca6e2",
      stroke: "none"
    },
    d: "M79 57L80 58L79 57M82.6667 57.3333L83.3333 57.6667L82.6667 57.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f35eb2",
      stroke: "none"
    },
    d: "M84 57L85 58L84 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be247a",
      stroke: "none"
    },
    d: "M85 57L86 58L85 57M31 58L31 59L34 59L31 58M44 58L44 59L47 59L44 58M56 58L56 59L59 59L56 58M64 58L65 59L64 58M72 58L73 59L72 58z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeesho);
export default __webpack_public_path__ + "static/media/meesho.8db94d7e86c8588cef06b90b2a2922c4.svg";
export { ForwardRef as ReactComponent };